module.exports = __webpack_public_path__ + "static/media/10b.fe8af1ef.png";